import bookingRequests from "@/services/bookingRequestsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async createCustomer({ dispatch }, { id }) {
    try {
      await bookingRequests.createCustomer({ id });
      dispatch(
        "common/showSuccess",
        "Gast wurde aus der Anfrage angelegt.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Gast konnte nicht angelegt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await bookingRequests.delete({ id });
      dispatch(
        "common/showSuccess",
        "Anfrage wurde erfolgreich archiviert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Anfrage konnte nicht archiviert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
